import { gql, useApolloClient, useQuery } from '@apollo/client'

import {
  SettingsQuery,
  SettingsQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useAuth, useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { clearStorage } from '@/core/native/storage'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { logout } = useAuth()
  const client = useApolloClient()
  const { router, routerPages } = useRouter()

  const { data } = useQuery<SettingsQuery, SettingsQueryVariables>(QUERY)

  return {
    state: {
      isMembershipPersonalInformationRequired:
        !!data?.user?.isMembershipPersonalInformationRequired,
    },
    actions: {
      onLogout: async () => {
        await Promise.all([logout(), client.clearStore(), clearStorage()])
        router.push(routerPages.Top)
      },
    },
  }
})

const QUERY = gql`
  query Settings {
    user {
      id
      isMembershipPersonalInformationRequired
    }
  }
`
